import { connect } from 'react-redux'
import { chatbotSelectors, chatbotEvents } from '../../../modules/ui/ChatBot'
import { PortfolioRentAndFeesForm } from '../../components'
import { portfolioApiSelectors } from '../../../modules/api/portfolio'
import { userApiSelectors } from '../../../modules/api/user'
import { uiEvents } from 'modules/ui/state'

const mapStateToProps = (state: any) => {
  const initialValues = chatbotSelectors.getLeaseRentAndFeesDialog(state)
  const currentPortfolioId = chatbotSelectors.getCurrentPortfolioId(state)
  return {
    initialValues,
    portfolioId: currentPortfolioId,
    isDraftPortfolio: portfolioApiSelectors.isDraftPortfolio(state)(currentPortfolioId),
    isReadOnly: userApiSelectors.isReadOnlyRole(state),
    leaseStartDate: chatbotSelectors.getLeaseTermInitialValues(state).startDate,
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    redirect: (path: any) => dispatch(uiEvents.redirect(path)),
    onSubmit: (values: any) => {
      dispatch(chatbotEvents.rentValuesSubmitted(values))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PortfolioRentAndFeesForm)
